// This enum defines the types of speed tests that can be performed, such as upload, download, or both.
export enum SpeedtestType {
	UPLOAD = 'Upload',
	DOWNLOAD = 'Download',
	UPLOAD_AND_DOWNLOAD = 'Upload and Download',
}
